import { Stack } from '@mui/material';
import { GridFilterPanel } from '@mui/x-data-grid-pro';
import { FilterPanelApplyButton, FilterPanelClearAllButton } from './grid.styles';

export const CustomGridFilterPanel = ({ handleApply, handleClearAll }: { handleApply: () => void, handleClearAll: () => void }) => {

  return (
    <>
      <GridFilterPanel />
      <Stack>
        <FilterPanelClearAllButton
          variant="contained"
          onClick={handleClearAll}
        >
          ClearAll
        </FilterPanelClearAllButton>
        <FilterPanelApplyButton
          variant="contained"
          onClick={handleApply}
        >
          Apply
        </FilterPanelApplyButton>
      </Stack>
    </>
  );
};